/** Product message-key syntax shared by the browser and bridge; no transport or host dependencies. */
export class WhatsAppMessageId {
    /** DOCUMENTED EXCEPTION: pure predicate; non-string or malformed input simply is not a message id.
     * ERROR-SUPPRESSED-JUSTIFIED: syntax classification preserves the existing ungated contract. */
    public static IsValid = (Value: unknown): boolean => {
        if (typeof Value !== "string") { return false; }
        return /^[A-Za-z0-9]{8,64}$/.test(Value);
    };
}
